import React from "react";
import { Link } from "react-router-dom";

export const LinkButton = props => <Link to={props.link}>
  <button type="button" className="btn btn-main">
    {props.title}
  </button>
</Link>
